export default "__VITE_ASSET__BpDhYr16__"